module.exports = __webpack_public_path__ + "static/img/l_mng.048c0500.png";